const otherValidationSchema = {
    description: {
      required: false,
    },
  };

export default otherValidationSchema;